import { c as _c } from "react/compiler-runtime";
import { Circle, ProgressCircle, Separator, HStack, IconButton, Link } from '@chakra-ui/react';
import { CardCarouselControlProps } from '@src/components/sco/CardCarousel/Controls/CardCarouselControlProps';
import { ArrowLeftIcon, ArrowRightIcon, ChevronLeftIcon, ChevronRightIcon } from '@src/components/sco/icons';
import React, { useEffect, useState } from 'react';
import { MdOutlinePause, MdPlayArrow } from 'react-icons/md';
export const BottomControl = props => {
  const $ = _c(35);
  const t0 = props.activeItemIndex === 0;
  let t1;
  if ($[0] !== props) {
    t1 = () => props.prevPage();
    $[0] = props;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ArrowLeftIcon />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t0 || $[4] !== t1) {
    t3 = <IconButton aria-label="Previous Page" disabled={t0} size="xs" title="Previous Page" variant="unstyled" onClick={t1}>{t2}</IconButton>;
    $[3] = t0;
    $[4] = t1;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = props.activeItemIndex === 0;
  let t5;
  if ($[6] !== props) {
    t5 = () => props.prevItem();
    $[6] = props;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <ChevronLeftIcon />;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t4 || $[10] !== t5) {
    t7 = <IconButton aria-label="Previous Item" disabled={t4} size="s" title="Previous Item" variant="unstyled" onClick={t5}>{t6}</IconButton>;
    $[9] = t4;
    $[10] = t5;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== props) {
    t8 = props.pages.map((_, i) => <Link key={i} display="block" onClick={() => props.goToPage(i)}><Circle bgColor={i === props.activePageIndex ? "white" : "rgba(255,255,255,0.25)"} margin="0.33em" size="0.5em" _hover={{
        bgColor: "rgba(255,255,255,.5)"
      }} /></Link>);
    $[12] = props;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const t9 = props.activeItemIndex === props.items.length - 1;
  let t10;
  if ($[14] !== props) {
    t10 = () => props.nextItem();
    $[14] = props;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <ChevronRightIcon />;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== t10 || $[18] !== t9) {
    t12 = <IconButton aria-label="Next Item" disabled={t9} size="s" title="Next Item" variant="unstyled" onClick={t10}>{t11}</IconButton>;
    $[17] = t10;
    $[18] = t9;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  const t13 = props.activeItemIndex === props.items.length - 1;
  let t14;
  if ($[20] !== props) {
    t14 = () => props.nextPage();
    $[20] = props;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <ArrowRightIcon />;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] !== t13 || $[24] !== t14) {
    t16 = <IconButton aria-label="Next" disabled={t13} size="xs" title="Next Page" variant="unstyled" onClick={t14}>{t15}</IconButton>;
    $[23] = t13;
    $[24] = t14;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  let t17;
  if ($[26] !== props) {
    t17 = props.autoCycleState.isDisabled === false && <AutoCycleControl {...props} />;
    $[26] = props;
    $[27] = t17;
  } else {
    t17 = $[27];
  }
  let t18;
  if ($[28] !== t12 || $[29] !== t16 || $[30] !== t17 || $[31] !== t3 || $[32] !== t7 || $[33] !== t8) {
    t18 = <HStack align="center" gap={0} justify="center" marginY="1em" maxWidth="100%" width="full">{t3}{t7}{t8}{t12}{t16}{t17}</HStack>;
    $[28] = t12;
    $[29] = t16;
    $[30] = t17;
    $[31] = t3;
    $[32] = t7;
    $[33] = t8;
    $[34] = t18;
  } else {
    t18 = $[34];
  }
  return t18;
};
export const AutoCycleControl = props => {
  const $ = _c(20);
  const [nextTransitionAt, setNextTransitionAt] = useState(null);
  let t0;
  if ($[0] !== props.autoCycleState.isPaused || $[1] !== props.autoCycleState.nextTransitionAt) {
    t0 = () => {
      if (!props.autoCycleState.isPaused) {
        setNextTransitionAt(props.autoCycleState.nextTransitionAt);
      }
    };
    $[0] = props.autoCycleState.isPaused;
    $[1] = props.autoCycleState.nextTransitionAt;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== props.autoCycleState.nextTransitionAt) {
    t1 = [props.autoCycleState.nextTransitionAt];
    $[3] = props.autoCycleState.nextTransitionAt;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  useEffect(t0, t1);
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Separator height="1em" orientation="vertical" />;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== props.autoCycleState.nextTransitionAt) {
    t3 = props.autoCycleState.nextTransitionAt.toString();
    $[6] = props.autoCycleState.nextTransitionAt;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const t4 = `progress-${t3}-${props.autoCycleState.isPaused ? "paused" : "active"}`;
  const t5 = `all ${props.autoCycleState.delay}ms ease-out !important`;
  let t6;
  if ($[8] !== t5) {
    t6 = {
      "& circle": {
        transition: t5
      }
    };
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const t7 = props.autoCycleState.isPaused || nextTransitionAt == props.autoCycleState.nextTransitionAt ? 100 : 0;
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <ProgressCircle.Circle css={{
      "--thickness": "1em"
    }}><ProgressCircle.Track /><ProgressCircle.Range stroke="whiteAlpha.500" /></ProgressCircle.Circle>;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t4 || $[12] !== t6 || $[13] !== t7) {
    t9 = <ProgressCircle.Root key={t4} size="xs" trackColor="primaryAlpha.500" css={t6} value={t7}>{t8}</ProgressCircle.Root>;
    $[11] = t4;
    $[12] = t6;
    $[13] = t7;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== props) {
    t10 = props.autoCycleState.isPaused ? <IconButton aria-label="Play" size="md" title="Play" variant="link" onClick={() => props.updateAutoCycleState({
      isPaused: false
    })}><MdPlayArrow /></IconButton> : <IconButton aria-label="Pause" size="sm" title="Pause" variant="link" onClick={() => props.updateAutoCycleState({
      isPaused: true
    })}><MdOutlinePause /></IconButton>;
    $[15] = props;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10 || $[18] !== t9) {
    t11 = <HStack align="center" gap="1em" marginLeft="0.5em">{t2}{t9}{t10}</HStack>;
    $[17] = t10;
    $[18] = t9;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  return t11;
};